var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-card",class:_vm.rootClassName},[_c('div',{staticClass:"card-info"},[_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"card-text1"},[_vm._v(_vm._s(_vm.text1))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }